<nz-layout class="ant-layout-parent">
    <nz-layout>
        <app-navbar></app-navbar>
        <nz-content>
            <router-outlet></router-outlet>
        </nz-content>
        <app-footer></app-footer>
    </nz-layout>
</nz-layout>